import React from 'react';
import styled from '@emotion/styled';
import colors, { white } from '../../../../../theme/colors';
import OfferFlagIcons from '../icons/OfferFlagIcons';
import { useOffers } from '../../../../../contexts/OffersContext';
import { isDarkMode } from '../../../../../utils/helpers';
import breakpoints from '../../../../../theme/material/breakpoints';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const ContainerWrapper = styled('div')(({ variant }) => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    display: 'inline-flex',
    padding: '13px 10px',
    alignItems: 'center',
    borderRadius: 15,
    border: `3px solid ${
      ['decline', 'counter'].includes(variant) ? colors[theme].red.primary : colors[theme].green.primary
    }`,
    background: white,
    position: 'absolute',
    right: ['accept', 'request', 'offer'].includes(variant) ? 10 : 'auto',
    left: ['decline', 'counter'].includes(variant) ? 10 : 'auto',
    top: 30,
    opacity: 0.6,
    [breakpoints.up(597)]: {
      right: ['accept', 'request', 'offer'].includes(variant) ? 20 : 'auto',
      left: ['decline', 'counter'].includes(variant) ? 20 : 'auto',
    },
  };
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const FlagTextWrapper = styled('div')(({ variant }) => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    color: ['decline', 'counter'].includes(variant) ? colors[theme].red.primary : colors[theme].green.primary,
    textAlign: 'center',
    fontSize: 22,
    fontStyle: 'normal',
    fontWeight: 700,
    letterSpacing: -0.44,
    textTransform: 'uppercase',
    marginLeft: 5,
  };
});

const OneTapSwipeOfferFlagOverlay: React.FC = () => {
  const { oneTapOfferFlagVariant } = useOffers();

  const renderLabel = () => {
    switch (oneTapOfferFlagVariant) {
      case 'decline':
        return 'Decline';
      case 'accept':
        return 'Accept!';
      case 'offer':
        return 'Offer!';
      case 'request':
        return 'Request!';
      case 'counter':
        return 'Counter!';
      default:
        return '';
    }
  };

  return (
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    <ContainerWrapper variant={oneTapOfferFlagVariant}>
      <OfferFlagIcons variant={oneTapOfferFlagVariant} />
      <FlagTextWrapper
        // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
        variant={oneTapOfferFlagVariant}
      >
        {renderLabel()}
      </FlagTextWrapper>
    </ContainerWrapper>
  );
};

export default OneTapSwipeOfferFlagOverlay;
